<template>
  <MainAuthLayout>
    <template v-slot:form>
      <div>
        <transition name="slide-fade-up">
          <b-img
            :src="require('@/assets/images/logo_centered.svg')"
            width="300"
            class="rounded-0"
          />
        </transition>

        <div class="qr-container mt-5">
          <h4 class="font-weight-bold">Verifying QR Code</h4>

          <b-spinner
            variant="primary"
            class="mt-3"
            label="Spinning"
            v-if="loading"
          ></b-spinner>

          <b-alert show variant="danger" v-show="errorMessage">{{
            errorMessage
          }}</b-alert>
        </div>
      </div>
    </template>
  </MainAuthLayout>
</template>

<script>
import Cookie from 'js-cookie'
import { mapActions } from 'vuex'
import MainAuthLayout from '@/layouts/MainAuthLayout'
export default {
  data() {
    return {
      errorMessage: '',
      loading: false
    }
  },
  components: {
    MainAuthLayout
  },
  methods: {
    ...mapActions({
      scanBoard: 'board/scanBoard'
    })
  },
  watch: {
    '$route.query.board_id': {
      handler(value) {
        this.loading = true
        Cookie.set('qr_board_id', value)
        if (this.$store.state.auth.user) {
          this.scanBoard({ board_id: value })
            .then(() => {
              this.loading = false
              this.$router.push({
                name: 'board.board-details-page',
                params: {
                  id: this.board.board_id,
                  name: this.board.site.name
                }
              })
            })
            .catch(_ => {
              this.loading = false
              Cookie.remove('qr_board_id')
              this.$router.push({ name: 'auth.login-page' })
            })
        } else {
          this.$router.push({ name: 'auth.login-page' })
        }
      },
      immediate: true
    }
  }
}
</script>
